

import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';
import { Binary } from '@angular/compiler';

export interface CommunicationSendMessageParameter extends Parameter {
    searchTerm: number;
    orderBy: string;

}

export interface CommunicationSendMessage {
   
    id?: any;
    tenantId: any;
    branchId: any;
   
    createdOn?:Date;
    //name:string;
    groupName:string;
    template:string;
    sendThrough:string;
    messageFrom:string;
    subject:string;
    attachment:string;
    messageFilter:string;
    deliveryDate:Date;
    deliveryStatus:string;
    total:number;
  startingDate: Date;
  endingDate: Date;
  scheduleDate: Date;

    parameters?: CommunicationSendMessageParameter[];
    links?: any;
}


export abstract class CommunicationSendMessageData {
    //abstract fireRequest(data: Department, method: string): Observable<any>;
    abstract list(url: string): Observable<CommunicationSendMessage[]>;
    abstract create(url: string, data: CommunicationSendMessage): Observable<CommunicationSendMessage[]>;
    abstract update(url: string, data: CommunicationSendMessage): Observable<CommunicationSendMessage>;
    abstract delete(url: string): Observable<any>;
}
